import FJActionConstant from "../../constant/FJActionConstant";
import FJCanvasStore from "../../store/FJCanvasStore";

let FJMoreAction = (function () {
  return {

    /**
     * @description 从核心代码更新ratio
     */
    updateRatioTypeFromCoreAction: function () {
      return (dispatch) => {
        dispatch(this.updateRatioTypeAction(FJCanvasStore.executeSync(FJCanvasStore.command.GET_RATIO)))
      }
    },

    /**
     * @description 设置视图的比例
     * @param ratioType
     */
    setRatioTypeAction: function (ratioType) {
      return (dispatch) => {
        FJCanvasStore.executeSync(FJCanvasStore.command.SET_RATIO, ratioType);
        dispatch(this.updateRatioTypeAction(ratioType));
      };
    },

    /**
     * @description 更新视图的比例
     * @param ratioType
     * @return {{ratioType, type: string}}
     */
    updateRatioTypeAction: function (ratioType) {
      return {
        type: FJActionConstant.SET_RATIO_TYPE,
        ratioType,
      }
    },

    /**
     * @description 鼠标进入ratio选项
     * @returns {(function(*, *))|*}
     */
    previewRatioTypeAction: function (ratioType) {
      return {
        type: FJActionConstant.SET_PREVIEW_RATIO_TYPE,
        ratioType,
      }
    },
  }
})();

export default FJMoreAction;
